const NOTIFICATION_CENTER_ROUTES = new Set([
  "/home/orderBlotter",
  "/home/fundRiskMonitorV2",
  "/home/fundRiskMonitorV3",
]);

export function isNotificationCenterRoute(path: string): boolean {
  const normalizedPath = path.length > 1 ? path.replace(/\/+$/, "") : path;
  return NOTIFICATION_CENTER_ROUTES.has(normalizedPath);
}

export function notificationDisplayPage(path: string): "risk_monitor" | "order_blotter" | null {
  if (!isNotificationCenterRoute(path)) return null;
  return path.replace(/\/+$/, "") === "/home/orderBlotter" ? "order_blotter" : "risk_monitor";
}
